<script setup lang="ts">
import StackedChart, { type SeriesItem } from './StackedChart.vue'

interface Props {
  currency: string
  locale?: string
  loading?: boolean
  series: SeriesItem[]
  title: string
  totalLabel: string
  totalValue: string
}

withDefaults(defineProps<Props>(), {
  locale: 'en-US',
  loading: false,
})
</script>

<template>
  <div class="rounded-lg border border-gray-200 bg-white px-4 py-3">
    <div class="flex items-start justify-between">
      <div class="font-medium leading-7 text-gray-700">
        {{ title }}
      </div>
      <div class="text-right">
        <div class="text-xl font-medium tracking-tight text-gray-900 sm:text-2xl">
          {{ totalValue }}
        </div>
        <div class="-mt-[2px] text-sm font-medium text-gray-700">
          {{ totalLabel }}
        </div>
      </div>
    </div>
    <div class="mt-6">
      <StackedChart :currency="currency" :loading="loading" :locale="locale" :series="series" />
    </div>
  </div>
</template>
